var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPostMagazineFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25.748,
  height: 19.999,
  viewBox: "0 0 25.748 19.999",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  d: "M25.748 0V19.999H0V0H25.748ZM13.9971 2.24219V17.7559H23.5303V2.24219H13.9971ZM2.22852 2.23047V17.7441H11.7617V2.23047H2.22852Z",
  fill: "black"
})));
export default SvgIconPostMagazineFlag;